import React from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation, Pagination, Autoplay } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import { motion } from "motion/react"

import rania from '../assets/images/days/rania.png'
import abdalmaged from '../assets/images/days/abdalmaged.png'
import aliBnMohamed from '../assets/images/days/aliBnMohamed.png'
import yousefBnAbdallah from '../assets/images/days/yousefBnAbdallah.png'
import ibrahemAlMoagal from '../assets/images/days/ibrahemAlMoagal.png'
import abdAlrahmanBnMkmy from '../assets/images/days/abdAlrahmanBnMkmy.png'
import mazenAldarab from '../assets/images/days/mazenAldarab.png'
import hanyAlShazly from '../assets/images/days/hanyAlShazly.png'
import safaBntAbdAllah from '../assets/images/days/safaBntAbdAllah.png'
import aliAboShawha from '../assets/images/days/aliAboShawha.png'
import khaledAlAsfor from '../assets/images/days/khaledAlAsfor.png'
import hodaAbdllah from '../assets/images/days/hodaAbdllah.png'
import ahmedAlMoedy from '../assets/images/days/ahmedAlMoedy.png'
import rakanIbrahem from '../assets/images/days/rakanIbrahem.png'
import torkyAlKhataf from '../assets/images/days/torkyAlKhataf.png'


import PartnersSection from '../components/sections/partners/Partners'
import StatsSection from '../components/sections/stats/Stats'
import Activities from '../components/sections/Activities/Activities'
import Vision from '../components/sections/Vision/Vision'
import AssociatedOrganizations from '../components/sections/AssociatedOrganizations/AssociatedOrganizations'
import About from '../components/sections/About/About'
import AboutTheConference from '../components/sections/AboutTheConference/AboutTheConference'
import Countdown from '../components/Countdown/Countdown'

import imanAlZoghby from '../assets/images/day2/imanAlZoghby.png'
import abdallahAlShamrany from '../assets/images/day2/abdallahAlShamrany.png'
import marawanAlbazghy from '../assets/images/day2/marawanAlbazghy.png'
import samyAlwahdan from '../assets/images/day2/samyAlwahdan.png'
import taghreedAlSerag from '../assets/images/day2/taghreedAlSerag.png'
import esraaAlSheref from '../assets/images/day2/esraaAlSheref.png'
import abdAlMegedAlAmzy from '../assets/images/day2/abdAlMegedAlAmzy.png'
import solimanAlHwesen from '../assets/images/day2/solimanAlHwesen.png'
import mashaalAlGhamdy from '../assets/images/day2/mashaalAlGhamdy.png'
import abdallahAlhayan from '../assets/images/day2/abdallahAlhayan.png'
import mohamedAlBatrawy from '../assets/images/day2/mohamedAlBatrawy.png'
import rodolfGozef from '../assets/images/day2/rodolfGozef.png'
import abdAlmeged from '../assets/images/day2/abdAlmeged.png'
import ossamaAlMosa from '../assets/images/day2/ossamaAlMosa.png'
import Royal from '../components/sections/royal/Royal'

import abdallahEldamagh from '../assets/images/day3/abdallahEldamagh.png'
import abdElmeged from '../assets/images/day3/abdElmeged.png'
import aliAboSharha from '../assets/images/day3/aliAboSharha.png'
import anasShalaan from '../assets/images/day3/anasShalaan.png'
import asmaaAlShemery from '../assets/images/day3/asmaaAlShemery.png'
import fahdAlFify from '../assets/images/day3/fahdAlFify.png'
import moaed from '../assets/images/day3/moaed.png'
import naserElSahly from '../assets/images/day3/naserElSahly.png'
import nizar from '../assets/images/day3/nizar.png'
import salehElHarthy from '../assets/images/day3/salehElHarthy.png'
import saraAlSheikh from '../assets/images/day3/saraAlSheikh.png'
import somya from '../assets/images/day3/somya.png'
import talalAbdElRahman from '../assets/images/day3/talalAbdElRahman.png'
import tawfeek from '../assets/images/day3/tawfeek.png'
import mobark from '../assets/images/day3/mobark.png'
import mohamedAlRaghy from '../assets/images/day2/mohamedAlRaghy.png'
import abdallahAlkaber from '../assets/images/day3/abdallahAlkaber.png'
import c7 from '../assets/images/agenda/c7.png'
import c8 from '../assets/images/agenda/c8.png'
import c9 from '../assets/images/agenda/c9.png'

export default function Home() {
  const dayOneSpeakers = [
    {
      name: 'د. رانيه بنت إبراهيم الجديد',
      title: 'عميد عمادة تطوير المهارات - جامعة الملك سعود',
      image: rania,
    },
    {
      name: 'عبدالمجيد بن محمد القصيبي',
      title: 'كبير مسؤولي الموارد البشرية ، جامعة الملك سعود',
      image: abdalmaged,
    },
    {
      name: 'أ.د. علي بن محمد مسملي',
      title: 'رئيس جامعة الملك سعود المكلّف',
      image: aliBnMohamed,
    },
    // {
    //   name: 'معالي الأستاذ. يوسف بن عبد الله البنيان',
    //   title: 'رئيس مجلس إدارة جامعة الملك سعود',
    //   image: yousefBnAbdallah,
    // },
    
    {
      name: 'د. ابراهيم سعد المعجل',
      title: 'شريك مؤسس ، شركة خوارزمي القابضة',
      image: ibrahemAlMoagal,
    },
    {
      name: 'د. بثينة بنت محمد الثويني',
      title: 'وكيل عمادة تطوير المهارات للتطوير والدراسات، جامعة الملك سعود',
      title2: ' مستشار اللغة والترجمة الحديثة فــي الإعلام الجديد',
      image: rania,
    },
    {
      name: 'د. عبد الرحمن بن مكمي الرويلي',
      title: 'الرئيس التنفيذي للمركز الوطني للمناهج',
      image: abdAlrahmanBnMkmy,
    },
    // {
    //   name: 'د. رانيــه بنت إبراهيم الجديد',
    //   title: 'عميد عمادة تطوير المهارات جامعة الملك سعود',
    //   image: rania,
    // },
    {
      name: 'أ. مازن الضراب',
      title: 'الرئيس التنفيذي لشركة زد ',
      title2: 'خريج جامعة الملك سعود',
      image: mazenAldarab,
    },
    {
      name: 'أ. هاني الشاذلي',
      title: 'المدير اإلقليمي لشركة PMI ',
      title2: 'شريك استراتيجي',
      image: hanyAlShazly,
    },
    {
      name: 'أ. صفاء بنت عبد الله الراشد',
      title: 'وكيل الوزارة المكلف لقدرات ووظائف المستقبل ',
      title2: 'وزارة الاتصالات وتقنية المعلومات',
      image: safaBntAbdAllah,
    },
    {
      name: 'أ.د. علي بن أحمد أبو شرحة',
      title: 'وكيل عمادة تطوير المهارات للبرامج والتدريب، جامعة الملك سعود',
      image: aliAboShawha,
    },
    {
      name: 'أ.د. خالد العصفور',
      title: 'أستاذ مشارك في تقنيات التعليم، جامعة الملك سعود',
      image: khaledAlAsfor,
    },
    {
      name: 'د. هدى عبد الله بن سعيدان',
      title: 'مستشار معالي وزير التعليم ',
      title2: 'والمشرف على ادارة علاقات المستثمرين',
      image: hodaAbdllah,
    },
    // {
    //   name: 'د. أحمد المعيدي',
    //   title: 'قسم الاعلام كليه العلوم الإنسانية والإجتماعية - جامعة الملك سعود',
    //   image: ahmedAlMoedy,
    // },
    {
      name: 'أ.د. راكان إبراهيم ناظر',
      title: 'أستاذ واستشاري جراحة القلب - جامعة الملك سعود',
      image: rakanIbrahem,
    },
    // {
    //   name: 'أ. صيتة السهلي',
    //   title: 'مشرف وحدة برامج أعضاء هيئة التدريس - بعمادة تطوير المهارات',
    //   image: rania,
    // },
    // {
    //   name: 'أ. منيره عبد الله الحمادي',
    //   title: 'وحدة البرامج التخصصية',
    //   image: rania,
    // },
    {
      name: 'أ. تركي الخطاف',
      title: 'مدير إدارة شؤون هيئة التدريس بعمادة الموارد البشرية',
      image: torkyAlKhataf,
    },
    // {
    //   name: 'أ. رنا العريني',
    //   title: 'مديرة ادارة تنمية الموارد البشرية بعمادة الموارد البشرية',
    //   image: rania,
    // },
  ]
  const dayTwoSpeakers = [
    {
      name: 'أ. ايمان الزعبي',
      title: 'نائب الرئيس التنفيذي للاستراتيجية ',
      title2: 'وعضو مجلس القادة السعودي',
      image: imanAlZoghby,
    },
 
    {
      name: 'أ. عبد الله الشمراني',
      title: 'المدير العام لمركز ريادة الإعمال الرقمية في وزارة الاتصالات وتقنية المعلومات',
      image: abdallahAlShamrany,
    },
 
    {
      name: 'أ. مروان البازعي',
      title: 'نائب الرئيس التنفيذي للجنة المنظمة لدورة ألعاب التضامن الإسلامي',
      image: marawanAlbazghy,
    },
 
 
    {
      name: 'أ. سامي الوهدان',
      title: 'عضـو المجلـس الاستشاري مجلـس التعليـم والتدريـب التقنـي والمهنـي، ',
      title2: 'رئيــس تطويــر الشــراكات الاستراتيجية - المركــز الوطنــي للشــراكات الاستراتيجية - كليــات التميــز',
      image: samyAlwahdan,
    },
 
    {
      name: 'د. تغريد السراج',
      title: 'المدير العام للتعليم وتنمية المواهب- وزارة الثقافة',
      image: taghreedAlSerag,
    },
    {
      name: 'د. يسرى بنت سعود المتحمي',
      title: 'وكيلة كلية علوم الحاسب والمعلومات لشؤون الطالبات',
      image: rania,
    },
    {
      name: 'د. منيرة العيسى',
      title: 'مديرة تكامل البيانات والخدمات المدعومة بالذكاء الاصطناعي',
      title2: 'وزارة الموارد البشرية والتنمية الاجتماعية',
      image: rania,
    },
    // {
    //   name: 'أ. إسراء محمد الشريف',
    //   title: 'المدير التنفيذي لاستراتيجية الأفراد والتخطيط، شركة نيوم',
    //   image: esraaAlSheref,
    // },
 
    // {
    //   name: 'أ. شذا مكي',
    //   title: 'المدير العام لأكاديمية التميز STC',
    //   image: rania,
    // },
 
    // {
    //   name: 'أ. أريج سعيد سالم باهمام',
    //   title: 'رئيس قسم المسؤولية المجتمعية المدينة الطبية الجامعية بجامعة الملك سعود',
    //   image: rania,
    // },
 
    {
      name: 'أ. عبدالمجيد العنزي',
      title: 'المشرف العام على فريق جامعة الملك سعود للعمل التطوعي مشرف نادي المسؤولية الأجتماعية ونادي التمريض ',
      image: abdAlMegedAlAmzy,
    },
    {
      name: 'م. سليمان الهويسين',
      title: 'مستشار وزارة الموارد البشرية والتنمية الأجتماعية',
      image: solimanAlHwesen,
    },
    // {
    //   name: 'أ. مشعل الغامدي',
    //   title: 'مشرف وحده شؤون المدربين بعمادة تطوير المهارات ومستشار مهني معتمد',
    //   image: mashaalAlGhamdy,
    // },
    {
      name: 'أ. عبدالله الحيان',
      title: 'مركز التميز لأمن المعلومات، جامعة الملك سعود ',
      title2: 'الرئيس التنفيذي، أراك العربية',
      image: abdallahAlhayan,
    },
    {
      name: 'أ. محمد بطراوي',
      title: 'مدير النجاح الشريك في المملكة العربية السعودية، PMI ',
      title2: 'شريك استراتيجي',
      image: mohamedAlBatrawy,
    },
    {
      name: 'أ. رودولف جوزف خوري',
      title: 'المدير الاقليمي - الشرق الأوسط وشمال أفريقيا، PMI ',
      title2: 'شريك استراتيجي',
      image: rodolfGozef,
    },
    {
      name: 'أ. سارة عبد الله آل الشيخ',
      title: 'طالبة طب وجراحة في جامعة الملك سعود رئيسة المجلس الطالبي بكلية الطب ',
      title2: 'ورئيسة نادي المسؤولية الاجتماعية',
      image: saraAlSheikh,
    },
    {
      name: 'د. محمد الراجحي',
      title: 'أستاذ مساعد بكلية العمارة والتخطيط',
      title2: 'جامعة الملك سعود',
      image: mohamedAlRaghy,
    },
    // {
    //   name: 'أ. نــــوره الــدوســـــري',
    //   title: 'رائــــــد أعمـــال',
    //   image: rania,
    // },
    // {
    //   name: 'أ. عبد المجيد العضياني',
    //   title: 'مشرف وحدة القياديين والإداريين',
    //   image: abdAlmeged,
    // },
    // {
    //   name: 'أ. هيا الدوسري',
    //   title: 'مشرف وحدة الطلاب',
    //   image: rania,
    // },
    // {
    //   name: 'أ. هناء الجنيدل',
    //   title: 'إدارة شؤون الموظفين عمادة الموارد البشرية',
    //   image: rania,
    // },
    // {
    //   name: 'أ. أسامة الموسى',
    //   title: 'مدير إدارة التوظيف عمادة الموارد البشرية',
    //   image: ossamaAlMosa,
    // }
  ]
  const dayThreeSpeakers = [
    {
      name: 'أ. عبدالمجيد بن محمد القصيبي',
      title: 'كبير مسؤولي الموارد البشرية بجامعة الملك سعود',
      image: abdElmeged,
    },
    {
      name: 'د. خلود العبدالكريم',
      title: 'مستشار نائب رئيس الجامعة للتخطيط والتطوير، جامعة الملك سعود',
      image: rania,
    },
    // {
    //   name: 'د. طلال عبدالرحمن الشثري',
    //   title: 'أستاذ مساعد - قسم الإعلام كلية العلوم الإنسانية والاجتماعية، جامعة الملك سعود',
    //   image: talalAbdElRahman,
    // },
    {
      name: 'أ. أسماء الشميمري',
      title: 'خبيــر برامــج فــي مؤسســة الملــك خالــد ',
      title2: 'وصانعــة محتــوى عــن التجــارب',
      image: asmaaAlShemery,
    },
    {
      name: 'د. صالح الحارثي',
      title: 'الرئيس التنفيذي لمجموعة ثروة',
      image: salehElHarthy,
    },
    {
      name: 'د. بثينة بنت محمد الثويني',
      title: 'وكيل عمادة تطوير المهارات للتطوير والدراسات، جامعة الملك سعود مستشار اللغة والترجمة الحديثة فــي الإعلام الجديد',
      image: rania,
    },
    {
      name: 'أ. معيض بن ناصر البيشي',
      title: 'مهندس معيض البيشي نائب الرئيس التنفيذي لقطاع الاستراتيجية والابتكار في بنك التنمية الاجتماعية',
      image: moaed,
    },
    {
      name: 'م. عبدالله بن علي الكبير',
      title: 'رئيس قطاع رأس المال البشري ',
      title2: 'وكالة الفضاء السعودية',
      image: abdallahAlkaber,
    },
    // {
    //   name: 'د.أنس الشعلان',
    //   title: 'مدير مركز الخريجين جامعة الملك سعود',
    //   image: anasShalaan,
    // },
    {
      name: 'أ. سوميا كانان',
      title: 'مدير التعليم وتنمية القوى العاملة، شركة IBM ',
      title2: 'شريك استرتيجي',
      image: somya,
    },
    {
      name: 'أ. ساره عجي الصحبي',
      title: 'مشرفة تربوية في وزارة التعليم بمنطقة الرياض',
      title2: 'ومديرة وحدة التطوع في اللجنه النسائية للتنمية المجتمعية بإمارة منطقة الرياض',
      image: rania,
    },
    {
      name: 'د. نادية عبد الله الشهراني',
      title: 'عضو هيئة تدريس ، مستشار في الحوكمة والمخاطر والالتزام بجامعة الأميرة نورة ',
      image: rania,
    },
    // {
    //   name: 'أ. غادة حمد المطلق',
    //   title: 'رئيسية قسم الالتزام في نيوم',
    //   image: rania,
    // },
    {
      name: 'أ. نزار العوفي',
      title: 'أخصائي استمرارية الأعمال في شركة أرامكو',
      image: nizar,
    },
    // {
    //   name: 'د.عبیر العتیبي',
    //   title: 'أستاذ مشارك في اللغويات التطبیقیة ومستشار، CIFAL',
    //   image: rania,
    // },
    {
      name: 'أ. عبدالله المديميغ',
      title: 'مترجم و معلم لغة اسبانية  ',
      title2: ' مدرب معتمد من المؤسسة العامة للتدريب التقني والمهنــي',
      image: abdallahEldamagh,
    },
    {
      name: 'أ. هديل بنت علي زين العابدين',
      title: 'المدير التنفيذي للشراكات الاستراتيجية، المركز الوطني لقياس أداء الأجهزة العامة، أداء',
      image: rania,
    },
    {
      name: 'د. فهد الفيفي',
      title: 'المدير التنفيذي للاستراتيجيات و تطوير الأعمال و الشراكات ',
      title2: ' المعهد الوطني لأبحاث الصحه',
      image: fahdAlFify,
    },
    {
      name: 'أ. ناصر السهلي',
      title: 'رئيس مجلس إدارة أكاديمية الحوكمة',
      image: naserElSahly,
    },
    {
      name: 'د. البندري بنت حسن الجميل',
      title: 'وكيل عمادة شؤون الطالب للتطوير والجودة جامعة الملك سعود',
      image: rania,
    },
    // {
    //   name: 'أ.د. علي بن أحمد أبو شرحة',
    //   title: 'وكيل عمادة تطوير المهارات للبرامج والتدريب، جامعة الملك سعود',
    //   image: aliAboSharha,
    // },
    {
      name: 'د. رانيه بنت إبراهيم الجديد',
      title: 'عميد عمادة تطوير المهارات، جامعة الملك سعود',
      image: rania,
    },
    {
      name: 'أ. توفيق الغامدي',
      title: 'مدير عام التمكين والتطوير ',
      title2: 'الهيئة العامة للأوقاف',
      image: tawfeek,
    },
    {
      name: 'د. مبارك البقمي',
      title: 'المدير العام للإدارة العامة للمسوْولية الأجتماعية ',
      title2: 'في وزارة الموارد البشرية و التنمية البشرية',
      image: mobark,
    }
  ]
  const sectionReveal = {
    initial: { opacity: 0, y: 30 },
    whileInView: { opacity: 1, y: 0 },
    transition: { duration: 0.6, ease: 'easeOut' },
    viewport: { once: true, amount: 0.2 },
  }

  const hoverShift = (idx = 0) => {
    const mod = idx % 3
    if (mod === 0) return { x: -6, y: -4 }
    if (mod === 1) return { x: 0, y: -6 }
    return { x: 6, y: -4 }
  }

  const agendaCards = [
    {
      img: c7,
      title: 'اليوم الاول',
      lines: ['بناء القدرات لمستقبل تنافسي'],
    },
    {
      img: c8,
      title: 'اليوم الثاني',
      lines: ['بناء المهارات للجيل القادم: التمكين للمستقبل'],
    },
    {
      img: c9,
      title: 'اليوم الثالث',
      lines: ['الأثر المجتمعي من خلال التدريب والتطوير'],
    },
  ]

  const agendaContainer = {
    hidden: {},
    show: {
      transition: { staggerChildren: 0.2 },
    },
  }

  const agendaCard = {
    hidden: { opacity: 0, y: 30, scale: 0.96 },
    show: {
      opacity: 1,
      y: 0,
      scale: 1,
      transition: { type: 'spring', stiffness: 160, damping: 18 },
    },
  }

  const storeLinks = [
    {
      name: 'App Store',
      href: 'https://apps.apple.com/us/app/tamkeen-x/id6757602988',
      secondary: 'App Store',
      icon: (
        <svg viewBox="0 0 24 24" className="h-6 w-6" fill="currentColor" aria-hidden="true">
          <path d="M18.71 12.63c-.01-2.25 1.84-3.33 1.92-3.38-1.05-1.53-2.68-1.74-3.26-1.76-1.38-.14-2.69.81-3.39.81-.7 0-1.78-.79-2.93-.76-1.5.02-2.88.9-3.64 2.29-1.55 2.68-.4 6.64 1.11 8.81.74 1.06 1.62 2.25 2.77 2.21 1.12-.05 1.54-.72 2.89-.72 1.35 0 1.73.72 2.92.69 1.21-.02 1.98-1.07 2.71-2.14.87-1.25 1.22-2.46 1.24-2.52-.03-.01-2.38-.91-2.4-3.52zm-2.26-6.5c.62-.76 1.04-1.8.93-2.85-.9.04-1.98.6-2.61 1.35-.57.66-1.07 1.72-.94 2.73.99.08 2-.5 2.62-1.23z" />
        </svg>
      ),
    },
    {
      name: 'Google Play',
      href: 'https://play.google.com/store/apps/details?id=com.arabnet.tamkeenx',
      secondary: 'Google Play',
      icon: (
        <svg viewBox="0 0 24 24" className="h-6 w-6" fill="currentColor" aria-hidden="true">
          <path d="M3.2 2.53a1.5 1.5 0 0 0-.2.77v17.4c0 .28.07.53.2.76l9.58-9.46z" />
          <path d="M14.02 9.69 4.8.97a1.4 1.4 0 0 1 .44-.25c.29-.1.62-.08.98.1l10.15 5.86z" />
          <path d="M14.25 14.42 6.22 21.1c-.52.37-.99.16-1.42-.07l9.45-9.43z" />
          <path d="M20.92 10.68 17.36 8.6l-3.3 3.3 3.2 3.2 3.66-2.11c.66-.38.66-1.31 0-1.7z" />
        </svg>
      ),
    },
  ]

  return (
    <div className="bg-gradient-to-b from-sky-50 to-white">
      <Countdown />

      <Royal />

      {/* Introduction Section */}
      <About />

      {/* About the Conference */}
      <AboutTheConference />

      {/* Vision and Mission */}
      <Vision />

      {/* Agenda Highlights */}
      <motion.section {...sectionReveal} className="mt-12 px-4 sm:px-8 pb-16">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-10">
            <p className="md:text-5xl text-3xl font-semibold text-sky-700">مـحـــاور المـلتـقــى</p>
          </div>

          <motion.div
            className="grid gap-6 lg:grid-cols-3"
            variants={agendaContainer}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, amount: 0.2 }}
          >
            {agendaCards.map((card, idx) => (
              <motion.div
                key={card.title}
                variants={agendaCard}
                whileHover={{ scale: 1.03, ...hoverShift(idx) }}
                className="relative overflow-hidden rounded-[32px] bg-white/95 border border-sky-100 shadow-[0_25px_60px_-20px_rgba(15,23,42,0.35)] backdrop-blur-sm"
              >
                <div className="absolute -left-12 -top-16 h-32 w-32 rounded-full bg-sky-200/30 blur-3xl" />

                <div className="relative h-full p-8 flex flex-col gap-6 items-center text-center">
                  <div className="w-28 h-28">
                    <img src={card.img} alt={card.title} className="w-full h-full" loading="lazy" />
                  </div>
                  <div className="space-y-2">
                    <h3 className="text-2xl font-extrabold text-[#28A2BD]">{card.title}</h3>
                    <div className="text-lg leading-relaxed text-slate-700">
                      {card.lines.map((line) => (
                        <p key={line}>{line}</p>
                      ))}
                    </div>
                  </div>
                </div>
              </motion.div>
            ))}
          </motion.div>

          <a
            href="https://cdn.ksu.edu.sa/ksu-subsites/dsd/TamkeenX.pdf"
            target="_blank"
            className="
              mx-auto mt-10 block max-w-[22rem]
              rounded-full bg-gradient-to-r from-sky-700 via-sky-600 to-cyan-500
              px-8 py-3 text-center text-2xl font-bold text-white
              shadow-[0_15px_30px_-15px_rgba(14,165,233,0.7)]
              transition duration-300
              hover:scale-[1.02] hover:shadow-[0_20px_36px_-18px_rgba(14,165,233,0.65)]
              focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-sky-200
            "
          >
             للإطلاع على برنامج الملتقى بصيغة PDF
            
          </a>
        </div>
      </motion.section>

      <StatsSection />

      {/* Day One Speakers */}
      <motion.section {...sectionReveal} className="bg-[#FFF] py-12">
        <div className="">
          <div className="text-center mb-10">
            <p className="text-xl font-semibold text-sky-700">قاعة حمد الجاسر - بهـو الجامعــة</p>
            <h2 className="text-3xl sm:text-4xl font-extrabold text-slate-900">متحدثو اليوم الأول</h2>
            <p className="mt-3 text-slate-600 text-lg">بناء القدرات لمستقبل تنافسي</p>
          </div>

          <Swiper
            dir="rtl"
            modules={[Navigation, Pagination, Autoplay]}
            spaceBetween={16}
            slidesPerView={1}
            loop
            // navigation
            pagination={{ clickable: true }}
            autoplay={{ delay: 4000, pauseOnMouseEnter: true, }}
            breakpoints={{
              640: { slidesPerView: 2 },
              900: { slidesPerView: 3 },
              1280: { slidesPerView: 4},
            }}
            className="!pb-12"
          >
            {dayOneSpeakers.map((speaker) => (
              <SwiperSlide key={speaker.name}>
                <motion.div
                  className="h-full  overflow-hidden flex flex-col items-center text-center"
                  whileHover={{ scale: 1.04, ...hoverShift(0) }}
                  transition={{ type: 'spring', stiffness: 240, damping: 18 }}
                >
                  <div className="relative w-full">
                    <div className="relative mx-auto flex items-end justify-center w-full overflow-hidden px-2 ">
                      <div className="absolute left-10 right-10 bottom-0 top-16  rounded-t-full bg-[#60346E]" ></div>
                      <img
                        src={speaker.image}
                        alt={speaker.name}
                        className=" w-[70%] mx-auto relative z-10"
                        loading="lazy"
                      />
                    </div>
                  </div>

                  <div className="w-full bg-[#60346E] p-3 flex-1 flex flex-col min-h-[100px]">
                    <div className="inline-flex items-center text-white justify-center  text-sm font-semibold">
                      {speaker.name}
                    </div>
                    {/* <h3 className="text-xl font-bold text-slate-900">{speaker.name}</h3> */}
                    <p className="text-sm leading-relaxed text-white">{speaker.title}</p>
                    {speaker.title2 && (
                      <p className="text-sm leading-relaxed text-white">{speaker.title2}</p>
                    )}
                  </div>
                </motion.div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </motion.section>

      {/* Day two Speakers */}
      <motion.section {...sectionReveal} className="bg-[#FFF] py-12">
        <div className="">
          <div className="text-center mb-10">
            <p className="text-xl font-semibold text-sky-700">مسرح الملتقـى - بهـو الجامعــة</p>
            <h2 className="text-3xl sm:text-4xl font-extrabold text-slate-900">متحدثو اليوم الثاني</h2>
            <p className="mt-3 text-slate-600 text-lg">بناء المهارات للجيل القادم: التمكين للمستقبل</p>
          </div>

          <Swiper
            dir="rtl"
            modules={[Navigation, Pagination, Autoplay]}
            spaceBetween={16}
            slidesPerView={1}
            loop
            // navigation
            pagination={{ clickable: true }}
            autoplay={{ delay: 4000, pauseOnMouseEnter: true, }}
            breakpoints={{
              640: { slidesPerView: 2 },
              900: { slidesPerView: 3 },
              1280: { slidesPerView: 4},
            }}
            className="!pb-12"
          >
            {dayTwoSpeakers.map((speaker) => (
              <SwiperSlide key={speaker.name}>
                <motion.div
                  className="h-full  overflow-hidden flex flex-col items-center text-center"
                  whileHover={{ scale: 1.04, ...hoverShift(0) }}
                  transition={{ type: 'spring', stiffness: 240, damping: 18 }}
                >
                  <div className="relative w-full">
                    <div className="relative mx-auto flex items-end justify-center w-full overflow-hidden px-2 ">
                      <div className="absolute left-10 right-10 bottom-0 top-16  rounded-t-full bg-[#60346E]" ></div>
                      <img
                        src={speaker.image}
                        alt={speaker.name}
                        className=" w-[70%] mx-auto relative z-10"
                        loading="lazy"
                      />
                    </div>
                  </div>

                  <div className="w-full bg-[#60346E] p-3 flex-1 flex flex-col min-h-[100px]">
                    <div className="inline-flex items-center text-white justify-center  text-sm font-semibold">
                      {speaker.name}
                    </div>
                    {/* <h3 className="text-xl font-bold text-slate-900">{speaker.name}</h3> */}
                    <p className="text-sm leading-relaxed text-white">{speaker.title}</p>
                    {speaker.title2 && (
                      <p className="text-sm leading-relaxed text-white">{speaker.title2}</p>
                    )}
                  </div>
                </motion.div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </motion.section>
      {/* Day three Speakers */}
      <motion.section {...sectionReveal} className="bg-[#FFF] py-12">
        <div className="">
          <div className="text-center mb-10">
          <p className="text-xl font-semibold text-sky-700">مسرح الملتقـى - بهـو الجامعــة</p>
            <h2 className="text-3xl sm:text-4xl font-extrabold text-slate-900">متحدثو اليوم الثالث</h2>
            <p className="mt-3 text-slate-600 text-lg">الأثر المجتمعي من خلال التدريب والتطوير</p>
          </div>

          <Swiper
            dir="rtl"
            modules={[Navigation, Pagination, Autoplay]}
            spaceBetween={16}
            slidesPerView={1}
            loop
            // navigation
            pagination={{ clickable: true }}
            autoplay={{ delay: 4000, pauseOnMouseEnter: true, }}
            breakpoints={{
              640: { slidesPerView: 2 },
              900: { slidesPerView: 3 },
              1280: { slidesPerView: 4},
            }}
            className="!pb-12"
          >
            {dayThreeSpeakers.map((speaker) => (
              <SwiperSlide key={speaker.name}>
                <motion.div
                  className="h-full  overflow-hidden flex flex-col items-center text-center"
                  whileHover={{ scale: 1.04, ...hoverShift(0) }}
                  transition={{ type: 'spring', stiffness: 240, damping: 18 }}
                >
                  <div className="relative w-full">
                    <div className="relative mx-auto flex items-end justify-center w-full overflow-hidden px-2 ">
                      <div className="absolute left-10 right-10 bottom-0 top-16  rounded-t-full bg-[#60346E]" ></div>
                      <img
                        src={speaker.image}
                        alt={speaker.name}
                        className=" w-[70%] mx-auto relative z-10"
                        loading="lazy"
                      />
                    </div>
                  </div>

                  <div className="w-full bg-[#60346E] p-3 flex-1 flex flex-col min-h-[100px]">
                    <div className="inline-flex items-center text-white justify-center  text-sm font-semibold">
                      {speaker.name}
                    </div>
                    {/* <h3 className="text-xl font-bold text-slate-900">{speaker.name}</h3> */}
                    <p className="text-sm leading-relaxed text-white">{speaker.title}</p>
                    {speaker.title2 && (
                      <p className="text-sm leading-relaxed text-white">{speaker.title2}</p>
                    )}
                  </div>
                </motion.div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </motion.section>

      {/* Activities Section */}
      <Activities />

      {/* Partners Section */}
      <PartnersSection />

      {/* Associated Organizations */}
      <AssociatedOrganizations />

      {/* Download Apps */}
      {/* <motion.section {...sectionReveal} className="px-4 sm:px-8 py-12">
        <div className="max-w-6xl mx-auto">
          <div className=" items-center rounded-[32px] bg-white/90 p-8 sm:p-12 shadow-[0_24px_70px_-30px_rgba(15,23,42,0.4)] border border-sky-100">
            <div className="space-y-4 text-center">
              <p className="text-4xl font-semibold text-sky-700 uppercase tracking-[0.08em]">تطبيق تمكين X</p>
              <h2 className="text-base sm:text-2xl font-extrabold text-slate-900 leading-snug">حمّل التطبيق واحصل على كل تفاصيل الملتقى في مكان واحد</h2>

              <div className="flex justify-center flex-wrap gap-3 pt-2">
                {storeLinks.map((link) => (
                  <a
                    key={link.name}
                    href={link.href}
                    target="_blank"
                    rel="noreferrer"
                    className="group min-w-[200px] flex items-center gap-3 rounded-2xl bg-gradient-to-r from-sky-700 via-sky-600 to-cyan-500 px-4 py-3 text-white shadow-[0_14px_32px_-18px_rgba(14,165,233,0.7)] transition duration-200 hover:scale-[1.02] hover:shadow-[0_20px_40px_-20px_rgba(14,165,233,0.7)] focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-sky-200"
                  >
                    <span className="flex h-11 w-11 items-center justify-center rounded-2xl bg-white/15 text-white">
                      {link.icon}
                    </span>
                    <span className="text-left leading-tight">
                      <span className="block text-xs opacity-90">{link.primary}</span>
                      <span className="block text-lg font-semibold">{link.secondary}</span>
                    </span>
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      </motion.section> */}
    </div>
  )
}
